import React, { PropsWithChildren } from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

export const LoadingWrapper = ({
  children,
  loading = false,
  size,
}: PropsWithChildren<{
  loading: boolean;
  size?: SpinProps['size'];
}>) => {
  if (loading) {
    return <Spin size={size}>{children}</Spin>;
  }

  return children;
};
